export const estimateTotalStudioHours = (production) => {
	return (
		(production?.pages &&
			production?.stats?.tempo &&
			production?.stats?.loss &&
			Math.ceil(production.pages / production.stats.tempo.average)) ||
		0
	);
};
